<template>
  <div class="flex flex-col gap-16 max-[768px]:gap-12">
    <ArticleCard
      v-if="firstArticle"
      :article="firstArticle"
      big-image
      :auto-height-image="windowWidth <= 768"
      class="!max-w-[unset]"
    />
    <div class="flex flex-wrap gap-x-8 gap-y-16 max-[768px]:flex-col max-[768px]:gap-12">
      <ArticleCard
        v-for="(article, index) in rest"
        :key="index"
        :article="article"
        :auto-height-image="windowWidth <= 768"
        class="!max-w-[27.5rem]"
      />
    </div>
    <div class="flex justify-between">
      <button
        :disabled="currentPage === 1"
        class="w-[2.75rem] h-[2.75rem] border border-[#EDE9E3] rounded-full flex items-center justify-center opacity-50"
        :class="[
          { 'hover:bg-[#33415512] !opacity-100': currentPage !== 1 }
        ]"
        @click="goToPreviousPage"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="currentColor"/>
        </svg>
      </button>
      <div class="flex gap-1">
        <span
          v-if="1 < shownPageButtons.at(0) && windowWidth > 460"
          class="flex items-center justify-center w-[2.75rem] h-[2.75rem] select-none"
        >
          ...
        </span>
        <button
          v-for="page in shownPageButtons"
          :key="page"
          :disabled="currentPage === page"
          class="w-[2.75rem] h-[2.75rem] rounded-md border border-[#EDE9E3] flex items-center justify-center text-[1.125rem] hover:bg-[#33415512]"
          :class="[
            { '!bg-[#334155] text-white font-bold': currentPage === page }
          ]"
          @click="goToSpecificPage(page)"
        >
          {{ page }}
        </button>
        <span
          v-if="totalPages > shownPageButtons.at(-1) && windowWidth > 460"
          class="flex items-center justify-center w-[2.75rem] h-[2.75rem] select-none"
        >
          ...
        </span>
      </div>
      <button
        :disabled="currentPage === totalPages"
        class="w-[2.75rem] h-[2.75rem] border border-[#EDE9E3] rounded-full flex items-center justify-center opacity-50"
        :class="[
          { 'hover:bg-[#33415512] !opacity-100': currentPage !== totalPages }
        ]"
        @click="goToNextPage"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.9999 4L10.5899 5.41L16.1699 11H3.99994V13H16.1699L10.5899 18.59L11.9999 20L19.9999 12L11.9999 4Z" fill="currentColor"/>
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
import ArticleCard from '../article-card/index.vue'

export default {
  name: 'ArticlesListing',
  components: {
    ArticleCard
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    firstArticle() {
      return this.articles[0]
    },
    rest() {
      return this.articles.slice(1)
    },
    maxPageButtons() {
      return this.windowWidth <= 768 ? 3 : 4
    },
    shownPageButtons() {
      const buttons = []
      for (let i = Math.max(1, this.currentPage - Math.floor(this.maxPageButtons / 2)); i <= this.totalPages; i++) {
        if (buttons.length === this.maxPageButtons) {
          break
        }
        buttons.push(i)
      }
      if (buttons.length < this.maxPageButtons) {
        for (let i = this.currentPage -(1 + Math.floor(this.maxPageButtons / 2)); i > 0; i--) {
          if (buttons.length === this.maxPageButtons) {
            break
          }
          buttons.unshift(i)
        }
      }
      return buttons
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  methods: {
    buildNextPath(page) {
      const params = new URLSearchParams(window.location.search)
      if (page) {
        params.set('page', page)
      } else {
        params.delete('page')
      }

      return `${window.location.pathname}?${params.toString()}`
    },
    goToPreviousPage() {
      if (this.currentPage === 2) {
        const nextPath = this.buildNextPath()

        window.open(nextPath, '_self')
        return
      }
      const nextPath = this.buildNextPath(this.currentPage - 1)

      window.open(nextPath, '_self')
    },
    goToNextPage() {
      const nextPath = this.buildNextPath(this.currentPage + 1)

      window.open(nextPath, '_self')
    },
    goToSpecificPage(page) {
      const nextPath = page === 1
        ? this.buildNextPath()
        : this.buildNextPath(page)
      
      window.open(nextPath, '_self')
    }
  }
}
</script>